<template>
  <z-dialog :show="isVisible" :modalSize="modalSize">
    <template v-slot:header>
      <h4 class="modal-title">
        {{ title }}
      </h4>
      <button type="button" class="btn-close" @click="close"></button>
    </template>
    <template v-slot:body>
      <div class="row">
        <div class="col">
          <z-textarea
            v-model="text"
            name="text"
            label="Comment"
            :rows="5"
            :maxlength="10000"
            @keyup="isSave = true"
          />
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-md-1"></div>
        <div class="col-md-6"></div>
        <div class="col-md-5">
          <div class="custom-buttons">
            <button
              v-show="isSave"
              class="btn btn-primary me-2"
              :disabled="isSaving"
              @click="performSave()"
            >
              <i v-if="isSaving" class="fas fa-spinner fa-spin"></i>
              Save
            </button>
            <button type="button" class="btn btn-secondary me-2" @click="close">
              Close
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZDialog from '@/Components/ZElements/Dialog'
import ZTextarea from '@/Components/ZElements/TextArea'
export default {
  name: 'comment-dialog',
  components: {
    ZDialog,
    ZTextarea,
  },
  props: {
    show: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalSize: 'modal-lg',
      isSave: false,
      isSaving: false,
    }
  },
  mounted() {
    this.isSave = false
    this.isSaving = false
  },
  computed: {
    ...mapGetters('users', ['profile']),
    ...mapGetters('feed', ['comment']),
    ...mapGetters('organizations', ['examineOrganization']),
    isVisible() {
      return this.show !== null
    },
    title() {
      let _title = ''
      if (this.show) {
        if (this.show.isAdd) {
          _title = 'New Comment'
        } else {
          _title = 'Edit Comment'
        }
      }
      return _title
    },
    orgId() {
      let _data = null
      if (this.examineOrganization) {
        _data = this.examineOrganization.id
      }
      return _data
    },
    text: {
      get() {
        let _data = null
        if (this.comment) {
          _data = this.comment.text
        }
        console.log('Comment (text)', this.comment)
        return _data
      },
      set(value) {
        let data = {
          name: 'text',
          value: value,
        }
        this.setCommentData(data)
      },
    },
  },
  methods: {
    ...mapActions('feed', [
      'setCommentData',
      'saveFeedComment',
      'editFeedComment',
    ]),
    close() {
      this.$emit('close')
    },
    validate() {
      let valid = true
      if (this.comment.text === '') {
        valid = false
      }
      return valid
    },
    async performSave() {
      let success = false
      let valid = this.validate()
      if (valid) {
        this.isSaving = true
        let results = null
        if (this.comment.id !== null) {
          // set up
          let post = {
            id: this.comment.id,
            text: this.comment.text,
            feedId: this.comment.feed_id,
          }
          // save
          console.log('Save Edit Comment', post)
          results = await this.editFeedComment(post)
        } else {
          console.log('Save Add Comment', this.comment)
          results = await this.saveFeedComment(this.comment)
        }
        this.isSaving = false
        console.log('Saved Comment', results)
        if (results) {
          if (results.error) {
            alert(results.error)
          } else {
            success = true
            this.isSave = false
            this.$emit('saved')
          }
        }
      } else {
        alert('Please provide a comment.')
      }
      return success
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-body {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-buttons {
  position: relative;
  float: right;
}
</style>
